module.exports = __webpack_public_path__ + "static/payBusiness-cddd3b0296efea1dfee05fb9af093235.svg";